module.exports = __webpack_public_path__ + "static/distances-b-3ab6cf891d757c1eb0c5040d25701ea8.png";